<template>
  <div class="item" v-if="item">
    <b-button @click="$router.go(-1)" variant="primary" class="no-print">Takaisin</b-button>
    <b-container class="head">
    <b-row >
      <b-col sm="4">
        <strong>Suunnittelija</strong><br/>
        {{ single.suunnittelija }}
      </b-col>
      <b-col>
        <strong>Työn nro.</strong><br/>
        {{ single.tyonro }}
      </b-col>
      <b-col>
        <strong>Tekijä</strong><br/>
        {{ single.tekija }}
      </b-col>
      <b-col>
        <strong>Pvm.</strong><br/>
        {{ single.pvm }}
      </b-col>
      <b-col sm="3">
        <strong>Tunnus</strong><br/>
        {{ single.tunnus }}
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="7">
        <strong>Rakennuskohde</strong><br/>
        {{ single.rakennuskohde }}
      </b-col>
      <b-col sm="5">
        <strong>Sisältö</strong><br/>
        {{ single.sisalto }}
      </b-col>
    </b-row>
    </b-container>
    <Item
      :item="item"
      :paloluokka="paloluokka"
      :pintaluokat="pintaluokat"
      :kayttotarkoitus="kayttotarkoitus"
    />
  </div>
</template>

<script>
import Item from '../components/Item.vue'
import kayttotarkoitukset from '../data/kayttotarkoitukset.js'

export default {
  name: 'PrintItem',
  components: { Item },
  data () {
    return {
      item: null,
      paloluokka: '',
      kayttotarkoitukset: kayttotarkoitukset,
      single: {},
      loading: false
    }
  },
  computed: {
    kayttotarkoitus: function () {
      return this.userSelection.kayttotarkoitus != null ? this.kayttotarkoitukset[this.userSelection.kayttotarkoitus].label : ''
    },
    pintaluokat: function () {
      var pmobj = {}
      if (this.userSelection.results.p1 !== null && this.paloluokka === '3') {
        pmobj = this.userSelection.results.p1.pintaluokat
      }
      if (this.userSelection.results.p2 !== null && this.paloluokka === '4') {
        pmobj = this.userSelection.results.p2.pintaluokat
      }
      if (this.userSelection.results.p3 !== null && this.paloluokka === '5') {
        pmobj = this.userSelection.results.p3.pintaluokat
      }
      return pmobj
    }
  },
  created: function () {
    this.single = this.userSelection.single
    const params = {
      rest_route: '/wp/v2/rakennusosa/' + this.$route.params.itemId
    }
    this.loading = true
    this.fetchData(params, data => {
      this.item = data
    })
  },
  updated: function () {
    if (this.item !== null) {
      window.print()
    }
  },
  methods: {
    fetchData (params, callback) {
      this.axios
        .get('https://epuu.wpengine.com/', { params })
        .then(response => {
          this.loading = false
          callback(response.data)
          console.debug(params)
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    }
  }
}
</script>

<style>
  .head {
    text-align: left;
  }
  @media print {
    #header, #footer, #navbar {
      display: none;
    }
    .no-print {
      display: none;
    }
  }
  @page{
    size: auto;
    margin: 3mm;
  }
</style>



// WEBPACK FOOTER //
// src/views/PrintItem.vue